import { CSSObject } from '@chakra-ui/react';
import mascot from '@/assets/magnumbet/images/header/card-hand.png';
import { CustomButtonProps } from '@/components/Button/Button';

export const BoxBallance: CSSObject = {
  borderX: '4px',
  borderColor: 'white',
  '> div:first-of-type': {
    color: 'beta.300',
    fontSize: 'sm',
    '> p': {
      fontWeight: 'semibold',
    },
  },
  '> div:last-of-type': {
    color: 'white',
    '> p': {
      fontSize: 'sm',
      fontWeight: 'semibold',
    },
    '> div': {
      '> p': {
        fontSize: 'sm',
      },
    },
  },
};

export const buttonDepositProps: CustomButtonProps = {
  variant: 'solid',
  textTransform: 'uppercase',
  w: 'full',
  mt: '2',
  borderRadius: 'base',
  sx: {
    '& svg': {
      textShadow: '0px 1px 2px rgba(0, 0, 0, 0.40)',
      mb: '1',
    },
  },
};

export const ButtonNavItem = (): CSSObject => ({
  fontSize: '13px',
  bg: 'white',
  color: 'gray.700',
  borderTop: '1px',
  borderColor: 'gray.300',
  fontFamily: 'accent',
  fontWeight: 'semibold',
  '&& > p': { transition: 'all 0.2s ease-in-out' },
  ':first-child': {
    borderTop: 'none',
  },
  '&:hover, &:active': {
    bg: 'gray.200',
  },
});

export const BoxMascotImage: CSSObject = {
  bgImg: `url(${mascot})`,
  bgRepeat: 'no-repeat',
  bgSize: '100%',
  top: '0.5',
  display: ['none', null, null, null, 'block'],
  pos: 'absolute',
  h: '57px',
  w: '105px',
  left: '-10px',
  'body[data-sensitive="true"] &': {
    display: 'none',
  },
};

export const PopoverHeaderQA: CSSObject = {
  bg: 'alpha.400',
  borderTop: '4px',
  borderX: '4px',
  borderColor: 'white',
  borderBottom: 'none',
  borderTopRadius: 'md',
  pb: '0',
  color: 'white',
  lineHeight: 'normal',
};

export const PopoverContentQA: CSSObject = {
  boxShadow: '2xl',
  fontFamily: 'accent',
  top: -2,
  _focus: {
    boxShadow: '2xl',
  },
  bg: 'alpha.800',
};

export const PopoverBodyQA: CSSObject = {
  bgGradient: 'linear(to-b, alpha.400, alpha.500)',
};

export const FlexBallanceItem: CSSObject = {
  p: {
    _last: { fontWeight: 'extrabold' },
  },
};

export const TextBalanceValue: CSSObject = {
  color: 'alpha.400',
  textShadow: '0px 2px 3px rgba(0, 0, 0, 0.2)',
  fontSize: 'sm',
  fontWeight: 'extrabold',
};

export const TextQuickAccessHello: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'bold',
};

export const buttonBalanceProps: CustomButtonProps = {
  variant: 'unstyled',
  display: 'flex',
  fontSize: 'xs',
  h: 'unset',
};
